export default {
  validations: {
    bcko: {
      required() {
        if (this.isUpdatePTEN) {
          return true;
        }
        return !!this.bcko;
      },
    },
    cmer: {
      required() {
        if (this.isUpdatePTEN) {
          return true;
        }
        return !!this.cmer;
      },
    },
    rmReferalCode: {
      isLength16() {
        if (this.isReferralCodeDisabled || !this.rmReferalCode) {
          return true;
        }
        return this.rmReferalCode.length <= 16;
      },
      isNotLeadingOrSpacesOnly() {
        if (this.isReferralCodeDisabled || !this.rmReferalCode) {
          return true;
        }
        if (/^\s+$/.test(this.rmReferalCode)) {
          return false;
        }
        return !/^\s/.test(this.rmReferalCode);
      },
      isAlphaNumWithSpace() {
        if (this.isReferralCodeDisabled || !this.rmReferalCode) {
          return true;
        }
        return /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/.test(this.rmReferalCode);
      },
    },
  },
  watch: {
    bcko: {
      handler() {
        if (this.$v?.bcko) {
          this.$v.bcko.$touch();
        }
        if (this.errorValidation?.bcko != null) {
          this.$store.commit('daftarTugas/rm/clearErrorVariable', 'bcko');
        }
      },
    },
    cmer: {
      handler() {
        if (this.$v?.cmer) {
          this.$v.cmer.$touch();
        }
        if (this.errorValidation?.cmer != null) {
          this.$store.commit('daftarTugas/rm/clearErrorVariable', 'cmer');
        }
      },
    },
    rmReferalCode: {
      handler() {
        if (this.$v?.rmReferalCode) {
          this.$v.rmReferalCode.$touch();
        }
        if (this.errorValidation?.referral_code != null) {
          this.$store.commit(
            'daftarTugas/rm/clearErrorVariable',
            'referral_code'
          );
        }
      },
    },
  },
  computed: {
    rmReferalCodeErrors() {
      const errors = [];
      if (!this.$v?.rmReferalCode?.$dirty) return errors;
      if (!this.$v.rmReferalCode.isLength16) {
        errors.push('Refferal Code must be 16 digit or less');
      }
      if (!this.$v.rmReferalCode.isNotLeadingOrSpacesOnly) {
        errors.push('Referral code cannot consist of spaces only');
      }
      if (
        this.$v.rmReferalCode.isNotLeadingOrSpacesOnly &&
        !this.$v.rmReferalCode.isAlphaNumWithSpace
      ) {
        errors.push('Only letters and numbers are allowed.');
      }
      if (this.errorValidation?.referral_code != null) {
        this.errorValidation.referral_code.forEach((item) => {
          errors.push(item);
        });
      }
      return errors;
    },
    bckoErrors() {
      const errors = [];
      if (this.$v?.bcko?.$dirty && !this.$v.bcko.required) {
        errors.push('BCKO is required');
      }
      if (this.errorValidation?.bcko != null) {
        this.errorValidation.bcko.forEach((item) => {
          errors.push(item);
        });
      }
      return errors;
    },
    cmerErrors() {
      const errors = [];
      if (this.$v?.cmer?.$dirty && !this.$v.cmer.required) {
        errors.push('CMER is required');
      }
      if (this.errorValidation?.cmer != null) {
        this.errorValidation.cmer.forEach((item) => {
          errors.push(item);
        });
      }
      return errors;
    },
  },
};